import { z } from 'zod'

/** Error envelope for every HTTP API (§28.2). */
export const ErrorCode = z.enum([
  'bad_request',
  'unauthorized',
  'forbidden',
  'not_found',
  'conflict',
  'rate_limited',
  'ai_policy_violation',
  'internal',
])
export type ErrorCode = z.infer<typeof ErrorCode>

export const ApiError = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.record(z.string(), z.unknown()).default({}),
  }),
})
export type ApiError = z.infer<typeof ApiError>

export const Me = z.object({
  user: z.object({
    id: z.uuid(),
    name: z.string(),
    email: z.email(),
    avatarUrl: z.string().nullable(),
    locale: z.string(),
    timezone: z.string(),
  }),
})
export type Me = z.infer<typeof Me>

export const Health = z.object({ ok: z.boolean(), service: z.string(), version: z.string(), db: z.boolean() })
export type Health = z.infer<typeof Health>
export * from './chat.ts'
export * from './error-reports.ts'
export * from './files.ts'
export * from './lists.ts'
export * from './live.ts'
export * from './m1.ts'
export * from './m2.ts'
export * from './m4.ts'
export * from './mcp.ts'
export * from './patch.ts'
export * from './people-m4.ts'
export * from './sources.ts'
export * from './time-tracking.ts'
